import cn from 'classnames'
import PropTypes from 'prop-types'
import React from 'react'

// noinspection HtmlUnknownTarget
const Footer = ({ className }) => (
  <footer className={cn('footer qa-footer', className)}>
    <ul className='nav'>
      <li className='nav-item'>
        <a
          href='/agb/' title='AGB' rel='nofollow'
          className='nav-link'
        >
          AGB
        </a>
      </li>
      <li className='nav-item'>
        <a
          href='/datenschutz/'
          title='Datenschutz'
          rel='nofollow'
          className='nav-link'
        >
          Datenschutz
        </a>
      </li>
      <li className='nav-item'>
        <a
          href='/impressum/'
          title='Impressum'
          rel='nofollow'
          className='nav-link'
        >
          Impressum
        </a>
      </li>
    </ul>
  </footer>
)

Footer.propTypes = {
  className: PropTypes.string
}

export default Footer
